import { useVariant } from '@unleash/proxy-client-react';
import { Alert } from 'src/components/ui/alert';

export default function OperationalMessage() {
  const variant = useVariant('operational-message');
  const message = variant.payload?.value;

  if (!variant.enabled || !message) {
    return null; // Don't render anything if the feature is not enabled or message is not set
  }
  return (
    <Alert
      zIndex="30"
      status="warning"
      h="44px"
      position="fixed"
      bottom="0"
      left="0"
      title={message}
    />
  );
}
